<template>
  <v-row>
    <v-col cols="12" :md="modalView ? 12 : 6" :offset-md="modalView ? 0 : 3">
      <form @submit.prevent="save">
        <v-text-field
          v-if="!opomba"
          v-model="form.name"
          label="Ime *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.name.required)"
        >
          <FormErrorsLine v-if="!$v.form.name.required" text="Polje je obvezno" />
        </FormErrors>

        <v-text-field
          v-if="opomba"
          v-model="form.comment"
          label="Opomba *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.comment.required)"
        >
          <FormErrorsLine v-if="!$v.form.comment.required" text="Polje je obvezno" />
        </FormErrors>

        <v-row v-if="barve">
          <v-col>
            <v-text-field
              v-model="form.color"
              label="Barva *"
              :disabled="true"
            ></v-text-field>
            <FormErrors
              v-if="$v.form.$error && (!$v.form.color.required)"
            >
              <FormErrorsLine v-if="!$v.form.color.required" text="Polje je obvezno" />
            </FormErrors>
          </v-col>
          <v-col>
            <ColorPicker v-model="color" />
          </v-col>
        </v-row>
        <v-btn type="submit" class="float-right">Shrani</v-btn>
        <v-btn v-if="!modalView && isNewLocation" type="button" class="float-right mr-4" @click="saveAndRepeat">Shrani in nov</v-btn>
        <v-btn text type="button" class="float-right mr-4" @click="cancel">Prekliči</v-btn>
      </form>
    </v-col>
  </v-row>
</template>

<script>
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'
import ColorPicker from '@/components/ColorPicker'
import requiredIf from 'vuelidate/lib/validators/requiredIf'

export default {
  components: {
    FormErrors,
    FormErrorsLine,
    ColorPicker
  },
  props: {
    barve: {
      default: true,
      type: Boolean
    },
    location: {
      default: () => {},
      type: Object
    },
    modalView: {
      default: false,
      type: Boolean
    },
    opomba: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      color: '#000000',
      emptyForm: {
        name: null,
        comment: null,
        color: '#000000'
      },
      form: {},
      localBarve: this.barve,
      localOpomba: this.opomba
    }
  },
  validations: {
    form: {
      name: {
        required: requiredIf(function() {
          return !this.localOpomba
        })
      },
      color: {
        required: requiredIf(vm => vm.localBarve)
      },
      comment: {
        required: requiredIf(function() {
          return this.localOpomba
        })
      }
    }
  },
  computed: {
    isNewLocation () {
      return this.location ? Object.keys(this.location).length === 0 : true
    }
  },
  methods: {
    save () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form })
      }
    },
    saveAndRepeat () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form, repeat: true })
      }
    },
    clearForm () {
      this.form = { ...this.emptyForm }
      this.color = '#000000'
      this.$v.$reset()
    },
    cancel () {
      this.$emit('cancel')
    }
  },
  created () {
    this.form = { ...this.emptyForm }
    if (!this.isNewLocation) {
      this.form = { ...this.form, ...this.location }
      this.color = this.location.color
    }
  },
  watch: {
    color (color) {
      this.form.color = color
    }
  }
}
</script>
